import * as C from "react";
import { forwardRef as t } from "react";
const H = t(function(e, L) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: L,
      viewBox: "0 0 76 16",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement("path", { d: "M72.606 16H13.6844L16.0002 0H75.3686L72.606 16Z", fill: "#000" }),
    /* @__PURE__ */ C.createElement("path", { d: "M15.7638 16H0L2.76256 0H18.5263L15.7638 16Z", fill: "#00FFB7" }),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M11.1057 2.5437L9.87837 6.59747L13.5644 8.15567L7.41965 13.4552L8.88289 9.40954L4.96094 7.84728L11.1057 2.5437Z",
        fill: "#000"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M25.7126 5.93543C25.9854 4.35522 25.1783 3.66174 23.7345 3.66174H23.5185C22.0747 3.66174 21.5858 4.54848 21.3471 5.93543L20.6309 10.0167C20.3467 11.6537 21.2789 12.3131 22.5976 12.3131H22.8136C24.2006 12.3131 24.7463 11.4718 24.9964 10.0167L25.7126 5.93543ZM23.5071 10.0281C23.3934 10.6988 23.1774 10.9944 22.7113 10.9944C22.2338 10.9944 22.0065 10.6533 22.1202 10.0281L22.8364 5.9468C22.9614 5.24195 23.1774 4.96911 23.6208 4.96911C24.0528 4.96911 24.3484 5.21922 24.2233 5.9468L23.5071 10.0281Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M25.8073 12.2108H28.3424C29.6953 12.2108 30.1159 11.5628 30.3546 10.2213L31.1277 5.82174C31.3892 4.32111 30.6843 3.75269 29.3542 3.75269H27.2965L25.8073 12.2108ZM28.5584 4.94637H29.0359C29.5588 4.94637 29.7521 5.20785 29.6384 5.84448L28.8995 10.0394C28.7972 10.6192 28.6266 10.9375 28.1037 10.9375H27.5125L28.5584 4.94637Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M31.2139 12.2108H33.7491C35.1019 12.2108 35.5225 11.5628 35.7613 10.2213L36.5343 5.82174C36.7958 4.32111 36.091 3.75269 34.7609 3.75269H32.7032L31.2139 12.2108ZM33.9651 4.94637H34.4425C34.9655 4.94637 35.1588 5.20785 35.0451 5.84448L34.3061 10.0394C34.2038 10.6192 34.0333 10.9375 33.5103 10.9375H32.9192L33.9651 4.94637Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M38.2349 10.1986L38.4168 9.16406H36.973L36.7684 10.3236C36.541 11.6196 37.3027 12.3017 38.7237 12.3017H38.9625C40.8042 12.3017 41.1679 10.7556 41.1679 9.73248C41.1679 8.83437 40.8042 8.41374 40.3381 7.79985L39.565 6.79943C39.2922 6.44701 39.1103 6.23101 39.1103 5.82174C39.1103 5.38974 39.2126 4.8668 39.8606 4.8668C40.2926 4.8668 40.4745 5.09416 40.3835 5.63985L40.2471 6.4129H41.6682L41.8159 5.57164C42.0547 4.2188 41.3157 3.66174 39.9856 3.66174H39.7469C38.0871 3.66174 37.5983 4.73037 37.5983 5.91269C37.5983 6.8449 37.9734 7.33374 38.3941 7.85669L39.1898 8.85711C39.4627 9.20953 39.6218 9.44827 39.6218 9.82343C39.6218 10.3577 39.4968 11.0285 38.8488 11.0285C38.4054 11.0285 38.1326 10.7897 38.2349 10.1986Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M43.415 12.2108H46.1775C47.4735 12.2108 47.8714 11.5742 48.076 10.3918L48.2693 9.28911C48.4853 8.04995 47.9396 7.7089 47.6668 7.58385C47.9624 7.52701 48.4967 7.28827 48.6672 6.33332L48.7922 5.62848C49.0196 4.35522 48.4057 3.75269 47.212 3.75269H44.9043L43.415 12.2108ZM46.7687 4.87816C47.3257 4.87816 47.4394 5.17374 47.3485 5.70806L47.2348 6.34469C47.1438 6.86764 46.9619 7.12911 46.4731 7.12911H45.7682L46.1661 4.87816H46.7687ZM46.1775 8.33416C46.7118 8.33416 46.8824 8.65248 46.7914 9.16406L46.6095 10.1986C46.5072 10.7784 46.3253 11.0285 45.8365 11.0285H45.0748L45.5522 8.33416H46.1775Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M54.2669 5.93543C54.5397 4.35522 53.7325 3.66174 52.2887 3.66174H52.0728C50.629 3.66174 50.1401 4.54848 49.9014 5.93543L49.1852 10.0167C48.901 11.6537 49.8332 12.3131 51.1519 12.3131H51.3679C52.7549 12.3131 53.3005 11.4718 53.5506 10.0167L54.2669 5.93543ZM52.0614 10.0281C51.9477 10.6988 51.7317 10.9944 51.2656 10.9944C50.7881 10.9944 50.5607 10.6533 50.6744 10.0281L51.3906 5.9468C51.5157 5.24195 51.7317 4.96911 52.1751 4.96911C52.6071 4.96911 52.9026 5.21922 52.7776 5.9468L52.0614 10.0281Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M59.7956 5.93543C60.0685 4.35522 59.2613 3.66174 57.8175 3.66174H57.6015C56.1577 3.66174 55.6689 4.54848 55.4302 5.93543L54.714 10.0167C54.4297 11.6537 55.3619 12.3131 56.6807 12.3131H56.8967C58.2836 12.3131 58.8293 11.4718 59.0794 10.0167L59.7956 5.93543ZM57.5902 10.0281C57.4765 10.6988 57.2605 10.9944 56.7944 10.9944C56.3169 10.9944 56.0895 10.6533 56.2032 10.0281L56.9194 5.9468C57.0445 5.24195 57.2605 4.96911 57.7038 4.96911C58.1358 4.96911 58.4314 5.21922 58.3064 5.9468L57.5902 10.0281Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M61.5046 10.1986L61.6865 9.16406H60.2427L60.0381 10.3236C59.8107 11.6196 60.5724 12.3017 61.9935 12.3017H62.2322C64.0739 12.3017 64.4377 10.7556 64.4377 9.73248C64.4377 8.83437 64.0739 8.41374 63.6078 7.79985L62.8347 6.79943C62.5619 6.44701 62.38 6.23101 62.38 5.82174C62.38 5.38974 62.4823 4.8668 63.1303 4.8668C63.5623 4.8668 63.7442 5.09416 63.6533 5.63985L63.5168 6.4129H64.9379L65.0857 5.57164C65.3244 4.2188 64.5855 3.66174 63.2554 3.66174H63.0166C61.3568 3.66174 60.868 4.73037 60.868 5.91269C60.868 6.8449 61.2432 7.33374 61.6638 7.85669L62.4596 8.85711C62.7324 9.20953 62.8916 9.44827 62.8916 9.82343C62.8916 10.3577 62.7665 11.0285 62.1185 11.0285C61.6752 11.0285 61.4023 10.7897 61.5046 10.1986Z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ C.createElement(
      "path",
      {
        d: "M65.9659 12.2108H67.4438L68.6944 5.0828H70.0245L70.2632 3.75269H66.1024L65.875 5.0828H67.2165L65.9659 12.2108Z",
        fill: "#fff"
      }
    )
  );
});
export {
  H as OddsboostFull
};
